import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data.service';
import { ApiService } from '../../services/api.service';
import { trace } from '@uirouter/angular';
import * as FileSaver from 'file-saver';
import { FrontEndService } from '../../services/front-end.service';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent implements OnInit {
  user_id = { 'user_id': this.dataService.userDetails['user_id'] };
  transactionsHistory = [];
  filterTransactions = [];

  isProduct: boolean;
  transactionLoading = true;
  filter = {
    code_type: ['check-product', 'pre-check', 'redeem_coupon', 'check_coupon'],
    isCodeTypeApplied: false,
    isRatedApplied: false,
    isExternalDBApplied: false,
    isDateApplied: false
  };

  @ViewChild("reviewModalContent") private reviewModalContent: ElementRef;
  @ViewChild("filterModal") private filterModalContent: ElementRef;
  @ViewChild("infoPanel") infoPanel;

  constructor(
    private dataService: DataService,
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private logService: LogService
  ) { }


  ngOnInit() {
    this.getTransactions();
  }

  transactionsCallBack = (response) => {
    if (response.response !== "error" ) {
      this.transactionsHistory = response.transactions;
      // this.logService.printLog("transaction history -", this.transactionsHistory);
      this.transactionLoading = false;
      this.filterTransaction(this.transactionsHistory);
    }
  }

  filterTransaction(transactions) {
    const arrayData = [];
    let obj = {};
    for (const i in transactions) {
      obj = JSON.parse(transactions[i].touch_goldKey_response);
      obj['ean'] = transactions[i].code;
      obj['read'] = transactions[i].read;
      obj['code_type'] = transactions[i].code_type;
      obj['transaction_id'] = transactions[i].transaction_id;
      obj['save_ratings'] = transactions[i].save_ratings;
      obj['date'] = transactions[i].touch_goldKey_date;
      obj['touch_externalDB'] = transactions[i].touch_externalDB;
      obj['touch_externalDB_response'] = JSON.parse(transactions[i].touch_externalDB_response);
      obj['save_ratings_request'] = JSON.parse(transactions[i].save_ratings_request);
      arrayData.push(obj);
    }
    this.filterTransactions = arrayData;
    // this.logService.printLog("filter transactions -", this.filterTransactions);
  }

  applyFilter(filterObject) {
    this.filterTransaction(filterObject["filterTransactions"]);
    this.filter = filterObject["filter"];
    this.logService.printLog("Filter object - ", this.filter);
  }

  getTransactions() {
    this.transactionLoading = true;
    this.apiService.getTransactions(this.user_id, this.transactionsCallBack);
  }

  noTransaction() {
    this.frontEndService.addToast('Info', "There is no transaction", 'info');
  }

  showLoader(show) {
    this.transactionLoading = show;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/transaction-history/transaction-history.component.ts